// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group-list-item{border-left:3px solid rgba(0,0,0,0);border-right:none}.group-list-item:first-child{border-top:none}.group-list-item:hover{background:var(--color-cloud-blue);border-left:3px solid var(--color-action-blue)}.group-list-item__hover{background:var(--color-cloud-blue);border-left:3px solid var(--color-action-blue)}", ""]);
// Exports
module.exports = exports;
